


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { RequestStatus } from "../utils/constans";
import { formatBackTime } from "../utils/common";
import { Notification } from "element-ui";
import { iResearchProject, iCopyRight } from "../typings/research";
import $api from "../api";
import mockProject from "../mock/project";
import mockCopy from "../mock/paten";

@Component
export default class CompResearch extends Vue {
  private projectList: iResearchProject[] = [];
  private enProjectList: iResearchProject[] = [];
  private copyRightList: iCopyRight[] = [];
  private enCopyRightList: iCopyRight[] = [];
  private content: string = "";
  private enContent: string = "";

  mounted() {
    this.getProjectList();
    this.getCopyRightList();
  }

  getProjectList() {
    const succ = (res: any) => {
      (res as any).map((record: iResearchProject) => {
        if (record.language === "英语" && this.enProjectList.length < 5) {
          this.enProjectList.push(record);
        } else if (record.language !== "英语" && this.projectList.length < 5) {
          this.projectList.push(record);
        }
      });
    };
    if (this.$store.state.offModel) {
      succ(mockProject);
    } else {
      $api.research.findAllresearchProjectClient().then(succ);
    }
  }

  getCopyRightList() {
    const succ = (res: any) => {
      (res as any).map((record: iCopyRight) => {
        if (record.language === "英语" && this.enCopyRightList.length < 5) {
          this.enCopyRightList.push(record);
        } else if (
          record.language !== "英语" &&
          this.copyRightList.length < 5
        ) {
          this.copyRightList.push(record);
        }
      });
    };
    if (this.$store.state.offModel) {
      succ(mockCopy);
    } else {
      $api.research.findAllPatentsCopyrightClient().then(succ);
    }
  }
}
